import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@creditas/stylitas'
import { Filter as CreditasFilter } from '@creditas/filter'
import { filterByPipelineStatus } from 'pipelines/assignments'

import { Bullet } from './Bullet'

const Filter = styled(CreditasFilter)`
  margin: 8px 4px;
`

const StatusFilter: FC<{
  assignments?: Workflow[]
  pipelineStatus: string
  active: boolean
  handleClick: () => void
}> = ({ assignments = [], pipelineStatus, active, handleClick }) => {
  const { t } = useTranslation(['surprise', 'common'])

  const assignmentsFiltered = filterByPipelineStatus(
    assignments,
    pipelineStatus,
    t,
  )

  return (
    <Filter
      selected={active}
      onClick={handleClick}
      data-testid={`${pipelineStatus}-filter`}
    >
      {t(`table.body.${pipelineStatus}`)} ({assignmentsFiltered.length || 0})
      <Bullet assignments={assignmentsFiltered} />
    </Filter>
  )
}

export { StatusFilter }
